import Form from '../../app-components/form/Form';
import {submit} from '../../AppServices';
import {PLACEHOLDER} from '../../app-components/utils';
import {cancelButton} from '../../app-components/action/CloseAction';
import {save} from '../../app-components/action/SaveAction';


export default ({uri, header}) => {
  const DrugForm = Form({
    type: 'standardShadow',
    uri,
    closeView: 1,
    reloadEvent: 'reloadDrug',
    onSubmit: submit({
      model: 'Drugs',
    }),
    mandatory: {name: 1},
    lg: {
      header,
      formGroups: [
        {
          columnsPerRow: 2,
          fieldVariant: 'filled',
          fieldContainer: 'topLabel',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  label: 'Drug Name',
                  placeholder: PLACEHOLDER,
                  mandatory: true,
                  width: '50%',
                },
                {
                  type: 'text',
                  field: 'code',
                  label: 'Drug Code',
                  placeholder: PLACEHOLDER,
                  mandatory: true,
                  width: '50%',
                },
              ],
            },
          ],
        },
      ],
    },
    sm: {
      header: {
        title: header.title,
      },
      footer: {
        actions: [cancelButton(), save()],
      },
      formGroups: [
        {
          columnsPerRow: 1,
          fieldVariant: 'filled',
          fieldContainer: 'topLabel',
          groups: [
            {
              columns: [
                {
                  type: 'text',
                  field: 'name',
                  label: 'Drug Name',
                  placeholder: PLACEHOLDER,
                  mandatory: true,
                },
              ],
            },
          ],
        },
      ],
    },
  });
  return DrugForm;
};
